const map = {
	"./SideMenu/arrow-circle-broken-right.svg": 57745,
	"./SideMenu/client.svg": 23983,
	"./SideMenu/dashboard.svg": 41138,
	"./SideMenu/dealer.svg": 97177,
	"./SideMenu/file-minus.svg": 87655,
	"./SideMenu/file-plus.svg": 91817,
	"./SideMenu/file.svg": 69024,
	"./SideMenu/home.svg": 22083,
	"./SideMenu/log-out.svg": 51263,
	"./SideMenu/machine.svg": 16621,
	"./SideMenu/passcode.svg": 2930,
	"./SideMenu/report.svg": 93508,
	"./SideMenu/service.svg": 63639,
	"./SideMenu/setting.svg": 70766,
	"./SideMenu/settings.svg": 9297,
	"./SideMenu/tag.svg": 39986,
	"./SideMenu/truck.svg": 97427,
	"./SideMenu/user-square.svg": 98681,
	"assets/Icons/SideMenu/arrow-circle-broken-right.svg": 57745,
	"assets/Icons/SideMenu/client.svg": 23983,
	"assets/Icons/SideMenu/dashboard.svg": 41138,
	"assets/Icons/SideMenu/dealer.svg": 97177,
	"assets/Icons/SideMenu/file-minus.svg": 87655,
	"assets/Icons/SideMenu/file-plus.svg": 91817,
	"assets/Icons/SideMenu/file.svg": 69024,
	"assets/Icons/SideMenu/home.svg": 22083,
	"assets/Icons/SideMenu/log-out.svg": 51263,
	"assets/Icons/SideMenu/machine.svg": 16621,
	"assets/Icons/SideMenu/passcode.svg": 2930,
	"assets/Icons/SideMenu/report.svg": 93508,
	"assets/Icons/SideMenu/service.svg": 63639,
	"assets/Icons/SideMenu/setting.svg": 70766,
	"assets/Icons/SideMenu/settings.svg": 9297,
	"assets/Icons/SideMenu/tag.svg": 39986,
	"assets/Icons/SideMenu/truck.svg": 97427,
	"assets/Icons/SideMenu/user-square.svg": 98681
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88782;